import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LoadMoreCTA, LoadMoreWrapper } from './LoadMore.style';
import Spinner from '../Spinner';

interface LodeMoreTypes {
  fetchMore: () => void;
  isLoadingMore: boolean;
  isLoading: boolean;
  setIsLoadingMore: (arg: boolean) => void;
}

const LoadMore: React.FC<LodeMoreTypes> = ({
  fetchMore,
  isLoadingMore,
  isLoading,
  setIsLoadingMore,
}) => {
  const { t } = useTranslation();

  const handleFetchMore = () => {
    fetchMore();
    setIsLoadingMore(true);
  };

  useEffect(() => {
    if (!isLoading) {
      setIsLoadingMore(false);
    }
  }, [isLoading, setIsLoadingMore]);

  return (
    <LoadMoreWrapper>
      {isLoadingMore ? (
        <Spinner size={40} />
      ) : (
        <LoadMoreCTA onClick={handleFetchMore}>{t('vlp.vehicleResults.loadMore')}</LoadMoreCTA>
      )}
    </LoadMoreWrapper>
  );
};

export default LoadMore;
